// extracted by mini-css-extract-plugin
export default {"linjeContainer":"Linje_linjeContainer__hiS0h","aktivLinje":"Linje_aktivLinje__6a8YU"};